import AppForm from '../app-components/Form/AppForm';

Vue.component('app-finance-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                // admin_user_id:  '' ,
                app_offices_id:  '' ,
                app_factories_id:  '' ,
                name:  '' ,
                type:  'cost' ,
                money:  0 ,
                // rest_money:  '' ,
                created_at:  null,
                made_at:  moment(),
                transfer_office_id:  null,
                source_type: 'CASH',
                source_balance_id: null,
                transfer_balance_id: null,
                app_farmer_drivers_id: null,

                /* special for credit finance */
                group_id: null,
            },
            tempFactory: null,
            tempOffice: null,
            tempOfficeTransfer: null,
            testDate: "2022-11-10 12:00:00",
            officeFinancialBalances: [],
            officeTransferFinancialBalances: [],
        }
    },
    methods:{
        onUpdateFactory(appFactory) {
            if (appFactory !== null) {
                this.form.app_factories_id = appFactory.id;
            }else{
                this.form.app_factories_id = "";
            }
        },
        onRemoveFactory(appFactory) {
            this.form.app_factories_id = "";
        },
        onSelectOffice(appOffice) {
            if (appOffice !== null) {
                this.form.app_offices_id = appOffice.id;
                this.setOfficeFinancialBalances()
            }else{
                this.form.app_offices_id = null;
                this.setOfficeFinancialBalances(true)
            }
        },
        onRemoveOffice(appFactory) {
            this.form.app_offices_id = null;
            this.officeFinancialBalances = [];
        },
        onSelectOfficeTransfer(appOffice) {
            if (appOffice !== null) {
                this.form.transfer_office_id = appOffice.id;
            }else{
                this.form.transfer_office_id = null;
            }
            this.setOfficeTransferFinancialBalances()
        },
        onRemoveOfficeTransfer(appFactory) {
            this.form.transfer_office_id = null;
            this.setOfficeTransferFinancialBalances()
        },
        setOfficeFinancialBalances (isEmpty) { 
            if (!this.isAdmin) {
                this.officeFinancialBalances = this.financialBalances[this.appOfficesId]||[]
                return
            }
            isEmpty = isEmpty || false
            if (isEmpty) {
                this.officeFinancialBalances = []    
            }else{
                this.officeFinancialBalances = this.financialBalances[this.form.app_offices_id]||[]
            }
        },
        setOfficeTransferFinancialBalances (isEmpty) { 
            isEmpty = isEmpty || false
            if (isEmpty) {
                this.officeTransferFinancialBalances = []    
            }else{
                this.officeTransferFinancialBalances = this.financialBalances[this.form.transfer_office_id]||[]
            }
         },
         onChangeTypeTransfer(){
            if (this.form.type=='closing') {
                console.log('closing')
                this.officeTransferFinancialBalances = this.financialBalancesHeadquarter||[]
            }
            
         },
         onChangeTransferbalanceId(officeBalance){
            if (this.form.type=='closing') {
                this.form.transfer_office_id = officeBalance.app_offices_id||null
            }
            
         }
    },
    computed: {
        isEdit: function () {
          return !isNaN(this.form.id)
        }
    },
    props:{
        selectedFactory: {
            type: Object,
            default: () => {}
        },
        selectedOffice: {
            type: Object,
            default: () => {}
        },
        selectedOfficeTransfer: {
            type: Object,
            default: () => {}
        },
        enableDateCreate: {
            type: Boolean,
            default: true
        },
        financialBalances: {
            type: Object,
            default: () => {}
        },
        financialBalancesHeadquarter: {
            type: Array,
            default: []
        },
        debtFinances: {
            type: Array,
            default: () => []
        },
        
    },
    mounted: function () {  
        this.tempFactory = this.selectedFactory
        this.tempOffice = this.selectedOffice
        this.tempOfficeTransfer = this.selectedOfficeTransfer
        /* console.log('this.form.created_at ', this.form.created_at, this.getDateFromString(this.form.created_at) ) */
        this.form.made_at = this.getDateFromString(this.form.made_at, this.dateFormat.ymdhis , this.dateFormat.ymdhis)
        this.form.created_at = this.getDateFromString(this.form.created_at, this.dateFormat.ymdhis , this.dateFormat.ymdhis)
        this.setOfficeFinancialBalances()
    },

});